import { isPbTimestamp } from "./isPbTimestamp";
export function toDate(value) {
    if (value == null) return undefined;
    if (isPbTimestamp(value)) {
        return new Date(Number(value.seconds) * 1000);
    }
    return new Date(value);
}
